export default {
  jobList: null,
  selectedJobKeys: [],
  userList: [],
  currentJob: null,
  currentJobModified: false,
  refreshingWorkerId: null,
};
